import React, { FunctionComponent, useMemo } from 'react';
import searchImage from '../../../static/group_image/search-icon.png';
import { useLoading } from '../../../contexts/LoadingContext';
import { useSearchHandler } from '../../../utils/useSearchHandler';
import { useCommonContent } from '../../../graphql/pimcore/modules/siteContent/hooks/useCommonContent';
import { useLocation } from 'react-router-dom';
import Image from 'next/image';

interface HeaderSearchBarProps {}

const HeaderSearchBar: FunctionComponent<HeaderSearchBarProps> = () => {
    const { setIsLoading, searchInput, setSearchInput } = useLoading();
    const { contentTree } = useCommonContent();

    // ⬇️ 讀取目前 URL 參數，若有 compare / doCompare 則保留
    const location = useLocation();
    const { compareParam, compareList, doCompare } = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const rawCompare = params.get('compare');
        return {
            compareParam: rawCompare,
            compareList: rawCompare ? rawCompare.split(',').filter(Boolean) : undefined,
            doCompare: params.get('doCompare') === 'true',
        };
    }, [location.search]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(event.target.value);
    };

    // 使用自訂 Hook，並把 setIsLoading 傳進去
    const { searchByKeyword } = useSearchHandler({ setIsLoading });

    // 按下 button or submit 時，呼叫同樣的搜尋邏輯
    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (!searchInput.trim()) return;

        await searchByKeyword(searchInput, {
            compare: compareList, // ⬅️ 將現有 compare 參數帶入
            doCompare, // ⬅️ 同步保留 doCompare flag
        });
        setSearchInput('');
    };

    return (
        <form onSubmit={handleSubmit} className="search-bar">
            <input
                type="text"
                placeholder={contentTree.search.globalSearchInputPlaceholder.content}
                value={searchInput}
                onChange={handleInputChange}
                title={contentTree.search.globalSearchInputTooltip.content}
            />
            <button type="submit">
                <Image
                    className="search-icon"
                    src={searchImage}
                    alt={contentTree.search.globalSearchInputIconAltText.content}
                />
            </button>
        </form>
    );
};

export default HeaderSearchBar;
